// TODO: rename private methods when used publicly
// TODO: reference documentation

/**
 data-gtm-event = "['click', 'mouseover']"
 data-options ='{"page" : {"formType": "#page.formType#","formName": "#page.formName#"},"events": {"category": "#events.category#","action": "#events.action#","label": "#events.label#"},"event":"iteraction.form.changeButton"}'
 data-gtm-update="value" => events.value
 */

/**
 * Push data to the dataLayer to end up in Google Tag Manager
 */
class GtmEvents {
    /**
     * Instance constructor
     * @param {HTMLElement} [element] The HTML element passed with
     * @param {Object} [data] Initial dataLayer data
     */
    constructor(element, data) {
        if (element) {
            this._element = element;
            this._datalayerData = data;
            this._eventsToBind = this._element.getAttribute("data-gtm-event");
            this._eventsToBind = this._eventsToBind.replace(
                /[`~!@#$%^&*()_|+\-=?;:'" .<>\{\}\[\]\\\/]/gi,
                ""
            );
            this._eventsToBind = this._eventsToBind.split(",");

            // data-gtm-update: updates de opgegeven property in de json: data-gtm-update="value" => events.value zie boven
            this._valueToUpdate = this._element.getAttribute("data-gtm-update");

            // TODO: Hmm, data-preventDefault is never applied in markup
            this._preventDefault = this._element.getAttribute(
                "data-preventDefault"
            );

            this._bindEvents(this._element);
        }
    }

    /**
     * Add GTM events as event handlers
     * @param {HTMLElement} element The HTML element to add event listeners
     * @private
     */
    _bindEvents(element) {
        for (let i = 0, len = this._eventsToBind.length; i < len; i++) {
            if (this._valueToUpdate === null) {
                element.addEventListener(
                    this._eventsToBind[i],
                    this._pushData.bind(this),
                    false
                );
            } else {
                element.addEventListener(
                    this._eventsToBind[i],
                    this._updateandPush.bind(
                        this,
                        this._valueToUpdate,
                        element
                    ),
                    false
                );
            }
        }
    }

    /**
     * Push the data to global window.dataLayer for Google Tag Manager to pick up
     * @param {Event} event
     * @private
     */
    _pushData(event) {
        // Hmm, event is never passed in here
        this._preventDefault && event && event.preventDefault();
        window.dataLayer &&
            this._datalayerData &&
            window.dataLayer.push(this._datalayerData);
    }

    /**
     * A static method for pushing to the data layer at runtime
     * @param {Object} data
     */
    static push(data) {
        data && window.dataLayer && window.dataLayer.push(data);
    }

    /**
     * Get the dataLayer data from the element
     * @param {HTMLElement} element
     * @private
     * @returns {Object}
     */
    _getdatalayerDataFromDom(element) {
        return JSON.parse(element.getAttribute("data-gtm-datalayer"));
    }

    /**
     * Setter for dataLayer data
     * @param {Object} data
     * @returns {Object}
     */
    set datalayerData(data) {
        this._datalayerData = data;
    }

    /**
     * Enrich dataLayer events with custom property
     * @param {String} property
     * @param {Object} data
     * @private
     */
    _appendTodatalayerData(property, data) {
        !this._datalayerData &&
            console.warn(
                `dataLayer not configured on element to set property ${property}`
            );
        if (this._datalayerData) {
            this._datalayerData["events"][property] = data;
        }
    }

    /**
     * Update a property value and push data
     * @param {String} property The property to set
     * @param {HTMLElement} element The element the get the value from
     * @private
     */
    _updateandPush(property, element) {
        if (element.type === "checkbox" || element.type === "radio") {
            this._appendTodatalayerData(property, element.checked);
        } else {
            this._appendTodatalayerData(property, element.value);
        }
        this._pushData();
    }
}

export default GtmEvents;
